import Player from '@vimeo/player';
import throttle from 'lib/throttle';

export default class ScreencastPlayer {
  constructor() {
    this.playerEl = document.querySelector('.video-player');
    this.buildPlaylist();

    let mnemo = window.location.hash;
    if (mnemo) {
      mnemo = mnemo.slice(1);
      let idx = this.playlist.findIndex(item => item.mnemo == mnemo);
      if (idx !== -1) {
        this.initPlayer(idx);
        document.querySelector('.screencast-player__nav').scrollTop = this.playlist[idx].el.offsetTop;
      }
    } else {
      this.initPlayer(0);
    }
  }

  bindHandlers() {
    for(let idx = 0; idx < this.playlist.length; idx++) {
      let item = this.playlist[idx];
      item.el.onclick = (e) => {
        e.preventDefault();
        this.setCurrentVideo(idx);
        this.scrollPlayerIntoView();
      };
    }

    window.addEventListener('resize', throttle(() => {
      this.onResize();
    }, 100));
  }

  scrollPlayerIntoView() {
    console.log(this.playerEl.getBoundingClientRect(), document.documentElement.clientHeight)
    if (this.playerEl.getBoundingClientRect().bottom < 0) {
      this.playerEl.scrollIntoView(true);
    }
  }
  
  onResize() {
    this.iframe.width = this.playerEl.offsetWidth;
    this.iframe.height = (this.iframe.width * this.playerAspectRatio).toFixed(4);
  }

  async setCurrentVideo(idx) {

    if (!this.player) {
      await this.initPlayer();
    } 
      
    await this.player.playVideoAt(idx);
  }

  buildPlaylist() {
    this.playlist = [];
    const links = document.querySelectorAll('.playlist-item[data-video-id]');
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const videoId = link.getAttribute('data-video-id');
      this.playlist.push({
        weight: link.querySelector('.playlist-item__id').innerHTML,
        videoId,
        title: link.querySelector('.playlist-item__name').innerHTML,
        el: link,
        mnemo: link.getAttribute('data-mnemo'),
        duration: link.getAttribute('data-duration')
      });
    }
  }

  getVideoSize() {
    this.currentWidth = this.playerEl.offsetWidth;
  }

  getVideoAspectRatio() {
    const width = this.iframe.width;
    const height = this.iframe.height;
    return (height / width).toFixed(4);
  }

  showPlaylistActiveIdx(idx) {
    const previousActive = document.querySelector('.playlist-item_active');
    if (previousActive) {
      previousActive.classList.remove('playlist-item_active');
    }
    this.playlist[idx].el.classList.add('playlist-item_active');
  }

  async initPlayer(idx = 0) {
    if (this.player) {
      this.player.destroy();
    }

    this.getVideoSize();

    if (!window.YT || !YT.Player) {
      await new Promise((resolve) => {
        window.onYouTubeIframeAPIReady = resolve;
      });
    }

    let videoId = this.playlist[idx].videoId;

    this.player = new YT.Player('player', {
      videoId: videoId,
      width: this.currentWidth,
      playerVars: {
        controls: 1,
        enablejsapi: 1,
        modestbranding: 1,
        rel: 0,
        listType: 'playlist',
        list: window.SCREENCAST_DATA.playlistId
      },
      events: {
        onReady: () => {
          this.iframe = this.playerEl.querySelector('iframe');

          this.playerAspectRatio = this.getVideoAspectRatio();
          this.bindHandlers();

          this.showPlaylistActiveIdx(idx);
        },
        onStateChange: ({data}) => {
          switch(data) {
            case YT.PlayerState.PLAYING:
              this.playerEl.classList.add("video-player_playing");
              let idx = this.player.getPlaylistIndex();

              this.showPlaylistActiveIdx(idx);
    
              window.location.hash = this.playlist[idx].mnemo;
    
              break;
            case YT.PlayerState.PAUSED:
              this.playerEl.classList.remove("video-player_playing");
              break;
          }
        }
      }
    });
    
  }


};
